import { FC } from 'react'

import { TEAL_DARK } from '../../utils/constants'

const VerifiedIcon: FC = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_38799_556814)">
      <path
        d="M14.6693 7.63527V8.24861C14.6685 9.68622 14.2029 11.0851 13.3422 12.2365C12.4814 13.3879 11.2715 14.2303 9.89284 14.6379C8.51422 15.0455 7.04078 14.9965 5.69225 14.4983C4.34372 14.0001 3.19237 13.0793 2.40991 11.8733C1.62745 10.6673 1.2558 9.24065 1.35039 7.80615C1.44498 6.37165 2.00074 5.00616 2.93479 3.91332C3.86884 2.82049 5.13113 2.05886 6.5334 1.74204C7.93567 1.42521 9.40278 1.57017 10.7159 2.15527"
        stroke={TEAL_DARK}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 2.91406L8 9.5874L6 7.5874"
        stroke={TEAL_DARK}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_38799_556814">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default VerifiedIcon
